import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";
import {Observable} from "rxjs";
import {Feature} from "@catcore/services/feature/feature";

@Injectable()
export class FeatureGgwDynRouteTemplateService  extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('feature-ggw-dynamic-route-templates', service);
  }

  create(item: any, feature: Feature): Observable<any> {
    const obj = {
      'model': item.model._links.self.href,
      'name': item.model.name,
      'feature': feature._links.self.href
    };
    console.log('Adding', obj);
    return this.queryAll()
      .post(obj)
      .map((createdTemplate) => {
        return createdTemplate;
      });
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-dynamic-routes/services/feature-ggw-dyn-route-templates.service.ts